<section
  class="tunnel-wash-summary"
  *ngIf="display as wash"
  [ngClass]="'tunnel-wash-summary--' + wash.tone"
  aria-label="Tunnel wash"
>
  <div class="tunnel-wash-summary__row">
    <span class="tunnel-wash-summary__label">Tunnel wash package</span>
    <span class="tunnel-wash-summary__value">{{ wash.packageName }}</span>
  </div>
  <div class="tunnel-wash-summary__row">
    <span class="tunnel-wash-summary__label">Status</span>
    <span class="tunnel-wash-summary__status">{{ wash.statusLabel }}</span>
  </div>
  <div class="tunnel-wash-summary__row" *ngIf="wash.timeLabel">
    <span class="tunnel-wash-summary__label">Time</span>
    <span class="tunnel-wash-summary__value">{{ wash.timeLabel }}</span>
  </div>
  <p class="tunnel-wash-summary__explanation" *ngIf="wash.explanation">
    {{ wash.explanation }}
  </p>
</section>
